<template>
  <div class="panel_shouyin">
    <div class="titleLine">
      <el-row>
        <el-col :span="6"> </el-col>
        <el-col :span="6"> </el-col>
        <el-col :span="2" :offset="22">
          <el-button @click="back" size="mini">返回</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="con">
      <div class="item" v-for="(petItem, petIndex) in pets_list" :key="petIndex">
        <div class="L">
          <div class="label">
            <span style="color: #fe2d2d">*</span>第{{
              $public.formatNumTochinese(petIndex + 1)
            }}只宠物
          </div>
          <div class="value">
            <el-select  v-model="petItem.petId" @change="changePet(petItem.petId, petIndex)" filterable placeholder="请选择" size="mini"
              style="width: 200px" clearable>
              <el-option v-for="item in userInfo.pets_info || []" :key="item._id" :label="item.nick_name"
                :value="item._id">
              </el-option>
            </el-select>
          </div>
          <div class="label"><span style="color: #fe2d2d">*</span>体重</div>
          <div class="value">
            <el-input v-model="petItem.weight" @input="inputWeight(petItem, petIndex)" size="mini" style="width: 130px">
              <template slot="append">kg</template>
            </el-input>
            <el-button type="warning" size="mini" style="margin-left: 4px; padding: 7px 8px"
              @click="open_drwaerXimeiSelectedService(petIndex)">添加服务</el-button>
          </div>
        </div>
        <div class="R">
          <el-table :data="petItem.tableData" height="396px" style="width: 100%" size="mini">
            <el-table-column label="项目">
              <template slot-scope="scope">
                {{ scope.row.title }} {{ scope.row.skuItem.extend_attr }}
                {{ scope.row.skuItem.service_objectName }}
              </template>
            </el-table-column>
            <!-- 原价 -->
            <el-table-column label="标准价/会员价" width="150">
              <template slot-scope="scope">
                <div v-if="scope.row.serviceId === $util.diffItemIdX ||
                  scope.row.serviceId === $util.diffItemIdM
                  ">
                  <el-input v-model="scope.row.skuItem.originalPrice" @input="changeNum(scope.row)"
                    size="mini"></el-input>
                </div>
                <div v-else>
                  {{ scope.row.skuItem.originalPrice }}/{{ scope.row.skuItem.mprice==0?scope.row.skuItem.originalPrice:scope.row.skuItem.mprice }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="customCode" label="洗美卡" width="120">
              <template slot-scope="scope">
                <el-select v-model="scope.row.cardId" @change="changeCardId(scope.row, petIndex, scope.$index)"
                  placeholder="请选择" size="mini" style="width: 100px" :disabled="!$public.isNull(scope.row.couponId) ||
                    !$public.isNull(scope.row.activityId) ||
                    scope.row.serviceId === $util.diffItemIdX ||
                    scope.row.serviceId === $util.diffItemIdM
                    " clearable>
                  <el-option v-for="item in scope.row.cardList" :key="item.card_number" :label="item.card_name +
                    '(' +
                    item.service_name +
                    ' ' +
                    item.service_object_name +
                    ')'
                    " :value="item.card_number"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="活动" width="150">
              <template slot-scope="scope">
                <el-select :disabled="!$public.isNull(scope.row.cardId) ||
                  scope.row.serviceId === $util.diffItemIdX ||
                  scope.row.serviceId === $util.diffItemIdM ||
                  !$public.isNull(scope.row.couponId)
                  " v-model="scope.row.activityId" @change="changeActivityId(scope.row, petIndex, scope.$index)"
                  placeholder="请选择" size="mini" style="width: 120px" clearable>
                  <el-option v-for="item in scope.row.activityList" :key="item._id" :label="item.name"
                    :value="item._id"></el-option>
                </el-select>
              </template>
            </el-table-column>

            <!-- ----------优惠券---------- -->
            <!-- {{ couponList }} -->
            <el-table-column label="优惠券" width="200">
              <template slot-scope="scope">
                <el-select v-model="scope.row.couponId" :disabled="!$public.isNull(scope.row.activityId) ||
                  !$public.isNull(scope.row.cardId)
                  " @change="changeCouponId(scope.row, petIndex, scope.$index)" placeholder="请选择" size="mini"
                  style="width: 180px" clearable>
                  <el-option v-for="item in scope.row.couponList" :key="item._no"
                    :label="item.coupon_name + '(' + item._no + ')'" :value="item._no"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="小计" width="80">
              <template slot-scope="scope">
                <div v-if="scope.row.serviceId === $util.diffItemIdX ||
                  scope.row.serviceId === $util.diffItemIdM
                  ">
                  <el-input v-model="scope.row.skuItem.price" @input="changeNum(scope.row)" size="mini"></el-input>
                </div>
                <div v-else>
                  {{ scope.row.skuItem.price }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="销售人员" width="120">
              <template slot-scope="scope">
                <el-select v-model="scope.row.salesMans" @change="
                  changeSaleManIdList(scope.row, petIndex, scope.$index)
                  " multiple filterable placeholder="请选择" size="mini" style="width: 110px">
                  <el-option v-for="item in staffList" :key="item._id" :label="item.basic_info.nick_name"
                    :value="item._id + ',' + item.basic_info.nick_name"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="delService(scope.row, petIndex, scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-row style="padding-top: 10px">
            <el-col :span="10">
              <span class="label">备注：</span>
              <span class="value">
                <el-input type="textarea" v-model="petItem.remark" @input="changeRemark" rows="2"
                  style="width: 200px; vertical-align: text-top" size="mini"></el-input>
              </span>
            </el-col>
            <div style="text-align: right">
              <span style="display: inline-block; margin-right: 20px">
                <el-button size="mini" @click="addDiffItemM(petIndex)">美容补差价</el-button>
              </span>
              <span>
                <el-button size="mini" @click="addDiffItemX(petIndex)">洗澡补差价</el-button>
              </span>
            </div>
          </el-row>
        </div>
      </div>
      <div>
        <el-button type="warning" @click="addPet" size="mini">
          +添加第{{ $public.formatNumTochinese(pets_list.length + 1) }}只
        </el-button>
      </div>
    </div>
    <!-- 赠品 -->
    <div v-if="drawerGift_state">
      <setGift :giveGoods="giveGoods" :useGoods="useGoods" @submit="submit_drawerGift"></setGift>
    </div>
    <div v-if="drwaerXimeiSelectedService_state">
      <ximeiSelectedService @closeOn="drwaerXimeiSelectedService_state = false" :curPetItem="pets_list[curPetIndex]"
        @submit="submit_drwaerXimeiSelectedService"></ximeiSelectedService>
    </div>
  </div>
</template>
<script>
import { getetMemberCanUseCoupon, getActivityPrice } from "@/api/newCoupon.js";
import setGift from "../../../../components/drawer/setGift.vue";
import ximeiSelectedService from "../drawer/ximeiSelectedService.vue";
export default {
  components: { setGift, ximeiSelectedService },

  data() {
    return {
      //
      xiMeiList: [],
      // 优惠券
      couponId: "",
      couponList: [],
      // 已使用优惠券id
      couponIdList: [],
      // 赠品
      drawerGift_state: false,
      giveGoods: {},
      giftTableData: [],
      goodsTableData: [],
      // 关联商品
      useGoods: {},
      // 所有洗美间
      // roomList:[],
      // 参数对象
      pets_list: [
        {
          petId: "",
          petItem: {},
          weight: "",
          cageId: "",
          roomItem: {},
          cageItem: {},
          tableData: [],
          remark: "",
        },
      ],
      // 所有洗美卡
      allCardList: [],
      // 选择服务
      curPetIndex: 0,
      drwaerXimeiSelectedService_state: false,

      // 最新体重
      newestWeight: "",
      // 类型
      typeId: 1,
      // 洗美卡
      cardNum: "",
      bindCardsList: [],
      // 销售人员
      saleManIdList: [],
      staffList: [],

      // 筛选
      screen1: "0",
      screen2: "0",
      // 洗美服务
      goodsId: "",
      serviceList: [],
      // 活动
      activityId: "",
      activityList: [],

      CalcGoodsPrice: [], //优惠后的价格//
      // 犬种 和 毛发
      screen1List: [
        // {code:'0',name:'不限'},
        { code: "11", name: "普通犬" },
        { code: "12", name: "特种犬" },
        { code: "21", name: "普通猫" },
        { code: "22", name: "特种猫" },
      ],
      screen2List: [
        // {code:'0',name:'不限'},
        { code: "1", name: "短毛" },
        { code: "2", name: "长毛" },
      ],
      flag: false,
      isMember: false,
    };
  },
  computed: {
    userInfo() {
      if (this.$store.state.mendian.userInfo._id) {
        return this.$store.state.mendian.userInfo;
      } else {
        return {
          basic_info: {},
          card_info: {},
          company_info: {},
          operation_info: {},
          pets_info: [],
          club_card: {},
        };
      }
    },
    curPetId() {
      return this.$store.state.mendian.curPetId;
    },
    curPetInfo() {
      return this.$store.getters["mendian/curPetInfo"];
    },
    addParams() {
      return this.$store.state.ximei.addParams;
    },
    money() {
      return this.$store.state.ximei.money;
    },
    curDiscountCard() {
      return this.$store.state.ximei.curDiscountCard;
    },
  },
  watch: {
    userInfo() {
      this.isMember = this.userInfo.club_card.is_valid;
    },
    curPetId() {
      this.screen1 = this.curPetInfo.pet_special;
      this.screen2 = this.curPetInfo.pet_hair;
      this.newestWeight = this.curPetInfo.weight;
      this.cardNum = "";
      this.addParams.cardNum = this.cardNum;
      this.$store.commit("ximei/set_addParams", this.addParams);
    },
  },
  mounted() {
    console.log(this.userInfo, 'this.userInfo');
    this.getStaffList();
    if (this.$store.state.yuyuePetId) {
      this.pets_list[0].petId = this.$store.state.yuyuePetId;
    }
    this.screen1 = this.curPetInfo.pet_special;
    this.screen2 = this.curPetInfo.pet_hair;
    this.newestWeight = this.curPetInfo.weight;

    // this.getRoomList();
    this.getBindCards();
  },
  methods: {
    async getUserCoupon(list) {
      console.log(list[0], "list");
      if (list.length) {
        for (var i = 0; i < list.length; i++) {
          console.log(list[i].skuItem,'------------price');
          let params = {
            member_id: this.userInfo._id,
            order_type_id: 0, //订单类型
            money: list[i].skuItem.price, //订单价格
            category_id: list[i].category_info._id, //分类id
            goods_id: list[i].serviceId, //商品id
            sku_id: list[i].skuItem.service_objectId,
            packing_way_id: "", //包装方式id
            use_scene: 2, //使用场景 0 全部 1线上 2线下
          };
          let res = await getetMemberCanUseCoupon(params);
          if (res.code == 0) {
            list[i].couponList = res.data;
          }
        }
        this.xiMeiList = list;
        this.getTable(this.xiMeiList);
      }
    },
    submit_drwaerXimeiSelectedService(obj) {
      let objList = JSON.parse(obj).list;
      console.log(objList, "添加的服务");
      this.getUserCoupon(objList);
    },
    getTable(list) {
      for (let i = 0; i < list.length; i++) {
        if (this.$public.isNull(list[i].skuItem.originalPrice)) {
          list[i].skuItem.originalPrice = list[i].skuItem.price;
        }
        if (list[i].skuItem.mprice>0&&this.userInfo.club_card.is_valid&&this.$public.isNull(list[i].couponId)&&this.$public.isNull(list[i].activityId)&&this.$public.isNull(list[i].cardId)) {
          list[i].skuItem.price = list[i].skuItem.mprice;
        }
        if (this.$public.isNull(list[i].couponId)) {
          list[i].couponId = "";
          list[i].couponItem = "";
        }
        if (this.$public.isNull(list[i].activityId)) {
          list[i].activityId = "";
          list[i].activityItem = "";
        }
        if (this.$public.isNull(list[i].cardId)) {
          console.log(this.pets_list[this.curPetIndex].petId,
            list[i], "0000000");
          let cardList = this.getCardCanUsed(
            this.pets_list[this.curPetIndex].petId,
            list[i]
          );
          list[i].cardList = cardList;
          if (cardList.length > 0) {
            list[i].cardId = cardList[0].card_number;
            list[i].cardItem = cardList[0];
            list[i].skuItem.price = 0;
          } else {
            list[i].cardId = "";
            list[i].cardItem = "";
          }
        }
        if (this.$public.isNull(list[i].giftList)) {
          list[i].giftList = [];
        }

        if (this.$public.isNull(list[i].salesMans)) {
          list[i].salesMans = [];
          this.$store.state.mendian.userController.map((controller) => {
            if (
              controller.invitationType === 2 &&
              controller.userId.length > 0
            ) {
              list[i].salesMans = [
                controller.userId + "," + controller.userName,
              ];
            }
          });
        }
        if (!this.$public.isNull(list[i].couponId)) {
          list[i].cardId = "";
          list[i].activityId = "";
          list[i].activityItem = "";
          list[i].cardItem = "";
          console.log(list[i], "-----------------");
        }
        if (!this.$public.isNull(list[i].cardId)) {
          list[i].couponId = "";
          list[i].activityId = "";
          list[i].activityItem = "";
          list[i].couponItem = "";
          console.log(list[i], "-----------------");
        }
        if (!this.$public.isNull(list[i].activityId)) {
          list[i].cardId = "";
          list[i].couponId = "";
          list[i].couponItem = "";
          list[i].cardItem = "";
          console.log(list[i], "-----------------");
        }
      }

      this.pets_list[this.curPetIndex].tableData = list;
      console.log(list, "项目数量详情");
      // let code=[]
      // list.map((item)=>{
      //    code.push(item.category_info.code)
      //   if(code.indexOf("beauty")!==-1){
      //    this.flag=true

      //   }else{
      //     this.flag=false
      //   }
      // })
      this.drwaerXimeiSelectedService_state = false;
      if (list.length > 0) {
        this.getActivityListByArr(this.pets_list[this.curPetIndex]);
      }
      this.$store.commit("ximei/set_addParams", this.pets_list);
      console.log(this.pets_list, "this.petlist");
    },
    back() {
      this.$store.commit("ximei/set_type", "list");
    },
    // 洗澡补差价
    addDiffItemX(petIndex) {
      let table = this.pets_list[petIndex].tableData;
      for (let i = 0; i < table.length; i++) {
        if (table[i].serviceId === "6347aae2fe1304b9a0ed2a64") {
          this.$message({
            message: "不能重复添加洗澡补差价项目",
            type: "error",
          });
          return;
        }
      }
      let obj = JSON.parse(JSON.stringify(this.$util.diffItemX));
      this.pets_list[petIndex].tableData.push(obj);
      console.log("obj", this.pets_list);
      this.$store.commit("ximei/set_addParams", this.pets_list);
    },
    // 美容补差价
    addDiffItemM(petIndex) {

      let table = this.pets_list[petIndex].tableData;

      for (let i = 0; i < table.length; i++) {
        if (table[i].serviceId === "6347aafbfe1304b9a0ed2acf") {
          this.$message({
            message: "不能重复添加美容补差价项目",
            type: "error",
          });
          return;
        }
      }
      let code = []
      table.map((item) => {
        code.push(item.category_info.code)
      })

      if (code.indexOf("beauty") !== -1) {
        let obj = JSON.parse(JSON.stringify(this.$util.diffItemM));
        this.pets_list[petIndex].tableData.push(obj);
        this.$store.commit("ximei/set_addParams", this.pets_list);
      } else {
        this.$message({
          message: "不含美容补差价项目",
          type: "error",
        });
        return;
      }
    },
    changeNum(row) {
      row.skuItem.price = this.$public.replaceGoodsDosage(row.skuItem.price);
      row.skuItem.originalPrice = row.skuItem.price;
      this.$store.commit("ximei/set_addParams", this.pets_list);
    },
    // 赠品
    openGift() {
      this.giveGoods.giftTableData = JSON.parse(
        JSON.stringify(this.giftTableData)
      );
      this.giveGoods.goodsTableData = JSON.parse(
        JSON.stringify(this.goodsTableData)
      );
      this.drawerGift_state = true;
    },
    submit_drawerGift({ giftTableData, goodsTableData }) {
      this.giftTableData = giftTableData;
      this.goodsTableData = goodsTableData;
      this.drawerGift_state = false;
      this.addParams.giftTableData = this.giftTableData;
      this.addParams.goodsTableData = this.goodsTableData;
      this.$store.commit("ximei/set_addParams", this.addParams);
    },
    // 切换宠物
    changePet(petId, petIndex) {
      let petItem = this.$public.getMatchingItem(
        this.userInfo.pets_info,
        "_id",
        petId
      );
      this.pets_list[petIndex].petItem = petItem;
      this.pets_list[petIndex].weight = petItem.weight || 0;
      this.pets_list[petIndex].cageId = "";
      this.pets_list[petIndex].roomItem = {};
      this.pets_list[petIndex].cageItem = {};
      this.pets_list[petIndex].tableData = [];
      this.pets_list[petIndex].remark = "";
      this.$store.commit("ximei/set_addParams", this.pets_list);
    },
    // 改变体重
    inputWeight(petItem, petIndex) {
      this.pets_list[petIndex].weight = this.$public.replaceGoodsDosage(
        petItem.weight
      );
      this.pets_list[petIndex].cageId = "";
      this.pets_list[petIndex].roomItem = {};
      this.pets_list[petIndex].cageItem = {};
      this.pets_list[petIndex].tableData = [];
      this.pets_list[petIndex].remark = "";
      this.$store.commit("ximei/set_addParams", this.pets_list);
    },
    // 改变洗美间
    // clickCage(roomItem,cageItem,petIndex){
    // 	this.pets_list[petIndex].cageId = cageItem.cage_id;
    // 	this.pets_list[petIndex].roomItem = roomItem;
    // 	this.pets_list[petIndex].cageItem = cageItem;
    // 	this.$store.commit('ximei/set_addParams',this.pets_list)
    // },
    // getRoomList(){
    // 	let params = {
    // 		roomType:2,  // 房间类型 1:寄养室 2:美容室 3:住院部 4:手术室 5:隔离室 6:传染病房 7:猫房 8:等待室 9:洗护室 10:大厅展示区 11:大厅 12:诊疗室
    // 	}
    // 	let loading = this.$loading()
    // 	this.$http.get('/api/Data/ShopRoom', params).then(res => {
    // 		loading.close()
    // 		if (res.code == 0) {
    // 			this.roomList = res.data;
    // 		}
    // 	})
    // },
    // 洗美服务
    open_drwaerXimeiSelectedService(petIndex) {
      if (this.$public.isNull(this.pets_list[petIndex].petId)) {
        this.$message({
          message: "请选择宠物",
          type: "error",
        });
        return;
      }
      if (this.$public.isNull(this.pets_list[petIndex].weight)) {
        this.$message({
          message: "宠物体重录入错误",
          type: "error",
        });
        return;
      }
      this.curPetIndex = petIndex;
      this.drwaerXimeiSelectedService_state = true;
    },

    delService(row, petIndex, rowIndex) {
      console.log(row, petIndex, rowIndex);
      this.$confirm("确定删除吗?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.pets_list[petIndex].tableData.splice(rowIndex, 1);
        this.$store.commit("ximei/set_addParams", this.pets_list);
        console.log(this.pets_list, "删除");
        // let code=[]
        // this.pets_list[petIndex].tableData.map((item)=>{
        //    code.push(item.category_info.code)

        // })
        // if(code.indexOf("beauty")==-1){
        //    if(code.indexOf(null)!==-1){

        //    }
        //   // this.pets_list[petIndex].tableData.splice(rowIndex, 1);
        //   }
      });


    },

    getCardCanUsed(petId, serviceItem) {
      let arr = [];
      for (let i = 0; i < this.allCardList.length; i++) {
        let cardItem = this.allCardList[i];
        if (petId === cardItem.pet_id) {
          arr.push(cardItem);
        } else {
          let isWeight = false,
            isSpecial = false,
            isHair = false;
          let cardSpecial = 50,
            cardHair = 50;
          if (
            cardItem.pet_special !== "0" &&
            !this.$public.isNull(cardItem.pet_special)
          ) {
            cardSpecial = Number(cardItem.pet_special);
          }
          if (
            cardItem.pet_hair !== "0" &&
            !this.$public.isNull(cardItem.pet_hair)
          ) {
            cardHair = Number(cardItem.pet_hair);
          }
          if (cardSpecial >= Number(serviceItem.skuItem.apply_varieties.code)) {
            isSpecial = true;
          }
          if (cardHair >= Number(serviceItem.skuItem.apply_features.code)) {
            isHair = true;
          }
          if (
            cardItem.weight_max >= serviceItem.skuItem.weight_detail.max_weight
          ) {
            isWeight = true;
          }
          if (
            isWeight &&
            isSpecial &&
            isHair &&
            serviceItem.serviceId === cardItem.service_id
          ) {
            arr.push(cardItem);
          }
        }
      }
      return arr;
    },
    getBindCards() {
      let params = {
        memberId: this.userInfo._id,
        isvalid: 1, // 是否有效 0：不限、1：有效、2：无效
      };
      let loading = this.$loading();
      this.$http.get("/api/Member/BindCards", params).then((res) => {
        loading.close();
        if (res.code == 0) {
          this.allCardList = res.data;
        }
      });
    },
    // 备注
    changeRemark() {
      this.$store.commit("ximei/set_addParams", this.pets_list);
    },
    // 活动
    changeActivityId(row, petIndex, rowIndex) {
      console.log(row, petIndex, rowIndex, "-----------");
      if (this.$public.isNull(row.activityId)) {
        console.log("取消活动",row.skuItem);
        if(this.userInfo.club_card.is_valid==true&&row.skuItem.mprice>0){
          row.skuItem.price = row.skuItem.mprice;
        }else{
          row.skuItem.price = row.skuItem.originalPrice;
        }
        row.couponId = "";
        row.cardId = "";
        row.couponItem = {};
        row.cardItem = {};
        row.activityItem = {};
      } else {
        row.couponId = "";
        row.cardId = "";
        row.couponId = "";
        row.couponItem = {};
        row.activityItem = {};
        row.giftList = [];
        let activityItem = this.$public.getMatchingItem(
          row.activityList,
          "_id",
          row.activityId
        );
        let calcResult = this.$public.calcActivity(
          activityItem,
          this.$public.cheng(row.skuItem.originalPrice, 1),
          1
        );
        console.log(calcResult);
        row.skuItem.price = this.$public.chu(calcResult.newPrice, 1);
        row.activityItem = activityItem;
        if (!this.$public.isNull(calcResult.gift.give_list)) {
          row.giftList = calcResult.gift;
          // this.drawerGift_state = true;
        }
      }
      this.$set(this.pets_list[petIndex].tableData, rowIndex, row);
      this.$store.commit("ximei/set_addParams", this.pets_list);
    },
    // 洗美卡
    changeCardId(row, petIndex, rowIndex) {
      if (this.$public.isNull(row.cardId)) {
        console.log("取消洗美卡", row.skuItem);
        if(this.userInfo.club_card.is_valid==true&&row.skuItem.mprice>0){
          row.skuItem.price = row.skuItem.mprice;
        }else{
          row.skuItem.price = row.skuItem.originalPrice;
        }
        row.couponId = "";
        row.activityId = "";
        row.activityItem = {};
        row.couponItem = {};
        row.cardItem = {};
      } else {
        console.log("洗美卡", row.skuItem);
        row.couponId = "";
        row.activityId = "";
        row.couponItem = {};
        row.cardItem = {};
        row.activityItem = {};
        row.skuItem.price = 0;
        row.cardItem = this.$public.getMatchingItem(
          row.cardList,
          "card_number",
          row.cardId
        );
      }
      this.$set(this.pets_list[petIndex].tableData, rowIndex, row);
      this.$store.commit("ximei/set_addParams", this.pets_list);
    },
    changeCouponId(row, petIndex, rowIndex) {
      console.log("优惠券11", row, petIndex, rowIndex);
      console.log(this.couponIdList, "存放已添加的优惠券--------------");
      if (petIndex == 0) {
        if (this.couponIdList.length) {
          for (let i = 0; i < this.couponIdList.length; i++) {
            if (this.couponIdList[i].index == rowIndex) {
              this.couponIdList[i].index = rowIndex;
              this.couponIdList[i].no = row.couponId;
            } else {
              if (this.couponIdList[i].no == row.couponId) {
                this.$message({
                  message: "该优惠券已使用过，请从新选择优惠券",
                  type: "error",
                });
                this.couponIdList.splice(i, 1);
                row.couponId = "";
                return;
              }
            }
          }
        }
      }

      let obj = { index: rowIndex, no: row.couponId };
      this.couponIdList.push(obj);
      console.log(this.couponIdList, "存放已添加的优惠券");
      if (this.$public.isNull(row.couponId)) {
        if(this.userInfo.club_card.is_valid==true&&row.skuItem.mprice>0){
          row.skuItem.price = row.skuItem.mprice;
        }else{
          row.skuItem.price = row.skuItem.originalPrice;
        }
      
        row.cardId = "";
        row.activityId = "";
        row.couponItem = {};
        row.activityItem = {};
        row.cardItem = {};
      } else {
        row.activityId = "";
        row.activityItem = {};
        row.couponItem = {};
        row.cardItem = {};
        let couponItem = this.$public.getMatchingItem(
          row.couponList,
          "_no",
          row.couponId
        );

        let params = {
          memberId: this.userInfo._id,
          originalPrice: row.skuItem.originalPrice,
          num: 1,
          couponNo: row.couponId,
        };
        getActivityPrice(params).then((res) => {
          if (res.code == 0) {
            if (Number(res.data) < 0) {
              res.data = 0;
            }
            row.skuItem.price = Number(res.data);
            row.couponItem = couponItem;
            this.$set(this.pets_list[petIndex].tableData, rowIndex, row);
            this.$store.commit("ximei/set_addParams", this.pets_list);
          }
        });
      }
    },

    getActivityListByArr(obj) {
      console.log(obj,'objobjximei');
      let arr = obj.tableData;
      for (let i = 0; i < arr.length; i++) {
        arr[i].goodsId = arr[i].serviceId;
        arr[i].skus = arr[i].skuItem.service_objectId;
        arr[i].skuValue = arr[i].skuItem.service_objectName;
        arr[i].brand = "";
        arr[i].categoryId = arr[i].category_info._id;
        arr[i].unitId = "";
        arr[i].customCode = "";
      }
      this.$util
        .getActivityOfProduct(this.userInfo, arr, obj.petItem)
        .then((res) => {
          for (let i = 0; i < arr.length; i++) {
            if (!this.$public.isNull(arr[i].couponId)) {
              continue;
            }
            arr[i].activityList = res[i].list;
            if (
              !this.$public.isNull(res[i].list) &&
              res[i].list[0].auto_matching > 0
            ) {
              if (this.$public.isNull(arr[i].activityId)) {
                if (this.$public.isNull(arr[i].cardId)) {
                  if (
                    this.$public.isNull(
                      this.curDiscountCard && this.curDiscountCard._no
                    )
                  ) {
                    arr[i].activityId = res[i].list[0]._id;
                    arr[i].activityItem = res[i].list[0];
                    let calcResult = this.$public.calcActivity(
                      arr[i].activityItem,
                      this.$public.cheng(arr[i].skuItem.originalPrice, 1),
                      1
                    );
                    console.log(calcResult,'calcResultcalcResultcalcResultcalcResult');
                    arr[i].skuItem.price = this.$public.chu(
                      calcResult.newPrice,
                      1
                    );
                    if (!this.$public.isNull(calcResult.gift.give_list)) {
                      arr[i].giftList = calcResult.gift;
                      // this.drawerGift_state = true;
                    }
                  }
                }
              }
            }
            this.$set(this.pets_list[this.curPetIndex].tableData, i, arr[i]);
          }
          this.$store.commit("ximei/set_addParams", this.pets_list);
        });
    },
    // 销售人员
    changeSaleManIdList(row, petIndex, rowIndex) {
      console.log(row, petIndex, rowIndex, "销售人员");
      if (this.$public.isNull(row.salesMans)) {
        console.log("取消销售人员");
      } else {
        console.log("改变销售人员2q112");
      }
      if (rowIndex === 0) {
        for (let i = 0; i < this.pets_list[petIndex].tableData.length; i++) {
          this.pets_list[petIndex].tableData[i].salesMans =
            this.pets_list[petIndex].tableData[0].salesMans;
        }
      }
      this.$set(this.pets_list[petIndex].tableData, rowIndex, row);
      this.$store.commit("ximei/set_addParams", this.pets_list);
    },
    getStaffList() {
      let params = {
        pageIndex: 1,
        pageSize: 500,
      };
      var ids = ["5efde71bf52ea9302466b224", "5ffff4edb810f200015c6a87", "5f48ccdbc72c871229261ae1", "5f9a9bc1c72c87189e699252", "61f263fb5e71469dac3e37f9", "60da829aa9f120030eccc273", "607a8159a9f1206061ca4243", "63f87adc0231057dd592a30a", "638850dee55ded240b8e72f8", "6520d228405e466e8490d2af", "6520d25c405e466e8490d2bd"];
      if (ids.includes(this.userInfo._id)) {
        params.position = "美容师,美容师助理,饲养员"
      } else {
        params.position = "美容师,美容师助理"
      }
      this.$http.get("/api/Staff/List", params).then((res) => {
        if (res.code == 0) {
          this.staffList = res.data.data;
          console.log(this.staffList, " this.staffList");
        }
      });
    },
    // 添加宠物
    addPet() {
      let a = {
        petId: "",
        petItem: {},
        weight: "",
        cageId: "",
        roomItem: {},
        cageItem: {},
        tableData: [],
        remark: "",
      };
      this.pets_list.push(a);
    },
  },
};
</script>
<style scoped lang="scss">
.panel_shouyin {
  height: 100%;
  padding-bottom: 60px;
  box-sizing: border-box;
  position: relative;

  .titleLine {
    width: 100%;
    background-color: #fff;
    height: 44px;
    padding: 8px 8px;
    box-sizing: border-box;
    margin-bottom: 4px;
    position: absolute;
    z-index: 1;
  }

  .con {
    padding: 44px 20px 30px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow: auto;

    &::-webkit-scrollbar {
      width: 4px;
      // height: 4px;
    }

    .item {
      display: flex;
      width: 100%;
      height: 450px;
      border-bottom: 1px solid #d4d4d4;
      padding-bottom: 18px;
      margin-bottom: 20px;

      .L {
        width: 248px;
        border-right: 1px dotted #d4d4d4;
        box-sizing: border-box;
        flex-shrink: 0;

        .label {
          font-size: 14px;
          color: $fontColor;
          padding: 14px 0 10px;
        }

        .value {
          &::-webkit-scrollbar {
            width: 4px;
            // height: 4px;
          }

          .roomItem {
            .roomName {
              font-size: 14px;
              color: #6e6e6e;
              padding: 0px 6px 6px;
            }

            .cageBox {
              display: flex;
              flex-wrap: wrap;

              .cageItem {
                width: 94px;
                height: 64px;
                box-sizing: border-box;
                background-color: #e8e8e8;
                position: relative;
                padding: 0 10px;
                text-align: center;
                cursor: pointer;
                border: 1px solid #cccccc;
                margin: 0 5px 5px;

                &.active {
                  background-color: #ffeed8;
                  border-color: #ffb254;
                }

                .cageName {
                  font-size: 12px;
                  color: #262626;
                  padding-top: 12px;
                }

                .checked {
                  height: 18px;
                  right: 0;
                  bottom: 0;
                  position: absolute;
                }
              }
            }
          }
        }
      }

      .R {
        width: 100%;
        padding-left: 16px;
        box-sizing: border-box;

        ::v-deep.el-table {}

        .beizhu {
          padding: 12px 0 0;
        }
      }
    }
  }
}
</style>
